import React from 'react';
import { getSelectedFilters, searchWithFilter } from './jobs-filter/CareersPageFilterService';
import { CS_Space, CS_Label } from '../visual_components';
import * as SVG_Icons from '../svg_icons';

export default function FilterInformationComponent() {
	const selected_filters = getSelectedFilters();
	function onFilterRemove(filter_type, value) {
		if (filter_type === 'selected_location') {
			const location_input_keys = ['loc', 'rsla', 'rslo', 'rsu', 'rsr'];
			location_input_keys.map(key => {
				if (document.querySelectorAll(`[name=${key}]`).length) {
					document.querySelectorAll(`[name=${key}]`)[0].disabled = true;
				}
			});
		} else {
			document.querySelectorAll(`[name=${filter_type}][value='${value}']`)[0].checked = false;
		}
		searchWithFilter();
	}
	if (selected_filters.length) {
		return (
			<div className="hidden-xs">
				<CS_Space vertical size={5} />
				<span>
					{SVG_Icons.funnel_icon}
					<CS_Space size={3} />
				</span>
				{selected_filters.map(({ option, key }) => (
					<CS_Label
						key={`${key}-${option.id}`}
						data={option}
						onRemove={() => onFilterRemove(key, option.id)}
					/>
				))}
				<a href="/">
					<button type="button" className="btn btn-default-link-secondary btn-sm">
						Clear all
					</button>
				</a>
			</div>
		);
	}
	return null;
}
